import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import blockSrc from '@cover/smombiesstoppen/block.png';
import bubbleOneSrc from '@cover/smombiesstoppen/bubble-1.png';
import bubbleTwoSrc from '@cover/smombiesstoppen/bubble-2.png';
import bubbleThreeSrc from '@cover/smombiesstoppen/bubble-3.png';

const AnimatedLayer = styled.img`
	position: absolute;
	z-index: 999;
`

const BlockOne = styled(AnimatedLayer)`
	height: 10.9%;
	top: 72.7%;
	left: 31.9%;
	opacity: 0;
`
const BlockTwo = styled(AnimatedLayer)`
	height: 10.5%;
	top: 64.5%;
	left: 49.5%;
	opacity: 0;
`
const BlockThree = styled(AnimatedLayer)`
	height: 10.8%;
	top: 57.3%;
	left: 49.3%;
	opacity: 0;
`
const BlockFour = styled(AnimatedLayer)`
	height: 11.2%;
	top: 59%;
	left: 55.3%;
	opacity: 0;
`


const BubbleOne = styled(AnimatedLayer)`
	height: 3.25%;
	top: 9%;
	left: 60%;
	opacity: 0;
`
const BubbleTwo = styled(AnimatedLayer)`
	height: 5%;
	top: 18%;
	left: 68%;
	opacity: 0;
`
const BubbleThree = styled(AnimatedLayer)`
	height: 2.5%;
	top: 28.5%;
	left: 57.2%;
	opacity: 0;
`

const SmombiesStoppen = ({ play }) => {
	const blocks = useRef(false);
	const bubbles = useRef(false);

	const blockOne = useRef(false);
	const blockTwo = useRef(false);
	const blockThree = useRef(false);
	const blockFour = useRef(false);

	const bubbleOne = useRef(false);
	const bubbleTwo = useRef(false);
	const bubbleThree = useRef(false);

	useEffect(() => {
		const timeline = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timeline
		.add({
			targets: blockOne.current,
			easing: 'easeInOutElastic(1, .6)',
			translateY: '19%',
			opacity: 1,
			duration: 400,
		})
		.add({
			targets: blockTwo.current,
			easing: 'easeInOutElastic(1, .6)',
			translateY: '19%',
			opacity: 1,
			duration: 300,
			endDelay: 300
		})
		.add({
			targets: blockThree.current,
			easing: 'easeInOutElastic(1, .6)',
			translateY: '19%',
			opacity: 1,
			duration: 300
		})
		.add({
			targets: blockFour.current,
			easing: 'easeInOutElastic(1, .6)',
			translateY: '19%',
			opacity: 1,
			endDelay: 50,
			duration: 300,
			endDelay: 800
		})
		.add({
			targets: bubbleOne.current,
			easing: 'easeInOutElastic(1, .6)',
			opacity: 1,
			scale: 2,
			duration: 600,
			endDelay: 1200,
		})
		.add({
			targets: bubbleTwo.current,
			easing: 'easeInOutElastic(1, .6)',
			opacity: 1,
			scale: 2,
			duration: 600,
			endDelay: 700,
		})
		.add({
			targets: bubbleThree.current,
			easing: 'easeInOutElastic(1, .6)',
			opacity: 1,
			scale: 2,
			duration: 600,
			endDelay: 1500,
		})
		.add({
			targets: [bubbles.current.children, blocks.current.children],
			easing: 'easeInOutElastic(1, .6)',
			opacity: 0,
			scale: .6,
			delay: anime.stagger(20)
		});
	
	}, [play])
	return (
		<>
			<div ref={blocks}>
				<BlockOne src={blockSrc} ref={blockOne} />
				<BlockTwo src={blockSrc} ref={blockTwo} />
				<BlockThree src={blockSrc} ref={blockThree} />
				<BlockFour src={blockSrc} ref={blockFour} />
			</div>
			<div ref={bubbles}>
				<BubbleOne src={bubbleOneSrc} ref={bubbleOne} />
				<BubbleTwo src={bubbleTwoSrc} ref={bubbleTwo} />
				<BubbleThree src={bubbleThreeSrc} ref={bubbleThree}/>
			</div>
		</>
	)
};

export default SmombiesStoppen;